import { render } from "./v-delete-product.vue?vue&type=template&id=89987908&scoped=true"
import script from "./v-delete-product.vue?vue&type=script&lang=js"
export * from "./v-delete-product.vue?vue&type=script&lang=js"

import "./v-delete-product.vue?vue&type=style&index=0&id=89987908&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-89987908"

export default script